import * as React from 'react';
import { ButtonSecondary, DraftPasswordBanner } from 'ui';
import { STATE } from 'app/constants';
import { containerFactory } from 'app/infrastructure/redux';
import { caseTranslations } from 'app/area/case/constants';
import { toDraft } from 'app/area/shared/route-urls';
import { toAbsoluteUrl } from 'app/infrastructure/hosting';
import { authProvider } from 'dependencies/auth';
import { CaseState } from 'app/area/case/types-store';
import { globalVar } from 'app/infrastructure/universal';
import { escapeUrl } from 'app/components/favourite-layout/favourite/common/utils';
import { Draft } from 'app/area/case/draft';
import styles from 'app/area/case/draft/draft-receipt.scss';
import { SpinLoader } from 'app/components';

interface DraftReceiptComponentProps {
  params: any;
  canRender: boolean;
  translation: any;
  children?: React.ReactNode;
  draftId: number;
  entityId: number;
  entity: any;
  route: any;
  shouldPrompt: boolean;
  connectToDraft: any[];
  favouriteComponent: any;
  shouldConfirmWarnings: boolean;
  router: any;
  sharedState: any;
  continue(e: React.SyntheticEvent<any>): void;
  cancel(): void;
  shouldDisplayModal: boolean;
  showSpinLoader: boolean;
}

class DraftReceiptComponent extends React.Component<DraftReceiptComponentProps> {
  public static statePath: string = STATE.case;
  

  public render() {
    const { params, canRender, showSpinLoader, translation } = this.props;
    const id = params.id;
    const anonCtx = globalVar('sessionStorage').getItem('anonCtx');

    const url = toAbsoluteUrl(toDraft(id, ''), true) + 
      (anonCtx ? `?anonCtx=${anonCtx}` : '');

    const handlePrint = (e: React.MouseEvent) => {
      e.preventDefault();
      window.print();
    };

    return (
      <>
        {canRender && 
          <div className={`container ${styles.draftReceipt}`}>
            {showSpinLoader ? <SpinLoader /> : 
              <DraftPasswordBanner textTitle={translation.public_case_saved_as_draft}>
                <p>{translation.public_follow_up_draft}</p>
                <p><a href={escapeUrl(url)}>{url}</a></p>
                <p>{translation.public_info_draft_password}</p>
                <p className={styles.casePassword}>{authProvider.getAuthorization()}</p>
                <div className={styles.print}>
                  <p>{translation.public_print_info}</p>
                  <ButtonSecondary onClick={handlePrint}>
                    {translation.public_print}            
                  </ButtonSecondary>
                </div>            
                <p className={styles.saveAsDraftInfo}>{translation.public_save_as_draft_info}</p>
              </DraftPasswordBanner>
            }
          </div>
        }
        <Draft {...this.props} />
      </>
    );
  }
}

const selectors = {
  canRender: (state: CaseState, props: any) => {
    const query = props.router.location?.query || {};
    return state.editing?.savingAsDraft || query?.saveAsDraft === 'true';
  },
  showSpinLoader: (state: CaseState) => state.editing?.savingAsDraft
};

export const DraftReceipt = containerFactory(
  DraftReceiptComponent,
  undefined,
  selectors,
  caseTranslations
);
